import { t as r } from "./to-positive-integer.js";
var t = RangeError,
  o = function o(_o, e) {
    var f = r(_o);
    if (f % e) throw t("Wrong offset");
    return f;
  };
export { o as t };